export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11878.f3841575.jpg";